module.exports = __webpack_public_path__ + "media/images/flags/id-7fb3c1a8b81db1c5e7d803f33bc3c8ed.svg";